import { Component } from '@angular/core';
import { debounce } from 'lodash-decorators';
import { CommunicationService } from 'src/app/communication/shared/communication.service';
import { UndeliverableEmailSearchDto } from 'src/app/communication/shared/undeliverable-email-search.dto';
import { UndeliverableEmailSearchResultDto } from 'src/app/communication/shared/undeliverable-email-searchResult.dto';
import { DatagridService, NotificationService, PagedResultGeneric } from 'src/app/shared';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { LazySelectableTableComponent } from 'src/app/shared/primeng/abstract-classes/lazy-selectable-table.component';

@Component({
  selector: 'wl-mass-comm-undeliverable-email-grid',
  templateUrl: './mass-comm-undeliverable-email-grid.component.html',
  styleUrl: './mass-comm-undeliverable-email-grid.component.less',
    standalone: false
})
export class MassCommUndeliverableEmailGridComponent extends LazySelectableTableComponent<
  UndeliverableEmailSearchDto,
  UndeliverableEmailSearchResultDto
> {
  exporting: boolean = false;
  public constructor(
    private _communicationService: CommunicationService,
    private _navigationService: NavigationService,
    private _notificationService: NotificationService,

    datagridService: DatagridService
  ) {
    super('', datagridService);
    this.searchParams = {
      PageNumber: 1,
      PageSize: 20,
    } as UndeliverableEmailSearchDto;
  }

  fetchResults(): Promise<PagedResultGeneric<UndeliverableEmailSearchResultDto>> {
    return this._communicationService.searchUndeliverableEmails(this.searchParams).then((result) => {
      return result;
    });
  }

  pageSizeChanged() {
    this.searchParams.PageNumber = 1;
    this.search();
  }

  @debounce(500)
  filterChanged() {
    this.searchParams.PageNumber = 1;
    this.search();
  }

  navigateToProfile(profileId: number) {
    this._navigationService.navigateToProfileView(profileId);
  }

  exportEmails() {
    this.exporting = true;
    this._communicationService
      .exportUndeliverableEmails(this.searchParams)
      .then((result) => {
        this._navigationService.popupSafeNavigate(result);
        this.exporting = false;
      })
      .catch((error) => {
        this._notificationService.httpError(error);
      });
  }
}
